export function getTimeZoneName(locale: string): string | null {
  try {
    const fmt = new Intl.DateTimeFormat(locale, { timeZoneName: 'shortGeneric' });
    const part = fmt.formatToParts(new Date()).find((p) => p.type === 'timeZoneName');
    if (part?.value) return part.value;
  } catch {
    return null;
  }

  return null;
}
